import axios from "common/helpers/axios.helper"

const reportError = (error) => {
    if (error.response) {
        if (error.response.status === 401) {
            console.log('ERROR(response): status: 401 -> Session ist abgelaufen', error.response)
        } else {
            console.log('ERROR(response): Ein Fehler ist aufgetreten!', error.response)
        }

    } else if (error.request) {
        console.log('ERROR(request)', error.request)
    } else {
        console.log('ERROR(request) setup?', error.message)
    }
}

export const getVersionList = () => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'VERSION_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/versions/${currentContainer}`),
            method: 'GET',
            responseType: 'json',
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'VERSION_LIST_SUCCESS', payload: response.data });
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'VERSION_LIST_ERROR', payload: error.response })
        });
    }
}

export const getVersion = (id, modalDialog = null, modalType = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'VERSION_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/versions/${currentContainer}/id/${id}`),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'VERSION_SELECT_SUCCESS', payload: response.data });
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'VERSION_SELECT_ERROR', payload: error.response })
        });
    }
}

export const createVersion = (data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'VERSION_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + '/api/v1/versions/' + currentContainer),
            method: 'POST',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'VERSION_CREATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getVersionList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'VERSION_CREATE_ERROR', payload: error.response })
        });
    }
}

export const updateVersion = (id, data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'VERSION_UPDATE_PENDING' });

        delete data.timestamp;

        axios({
            url: encodeURI(apiURL + `/api/v1/versions/${currentContainer}/id/${id}`),
            method: 'PATCH',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'VERSION_UPDATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getVersionList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'VERSION_UPDATE_ERROR', payload: error.response })
        });
    }
}

export const deleteVersion = (id) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'VERSION_DELETE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/versions/${currentContainer}/id/${id}`),
            method: 'DELETE',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'VERSION_DELETE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getVersionList())
        }).catch((error) => {
            reportError(error)
            dispatch({ type: 'VERSION_DELETE_ERROR', payload: error.response })
        });
    }
}